<template>
  <dragModal :title="$t('page_my_document_advanced')" :subTitle="`(${$t('page_material_customer_information')})`" top="120px" :visible="visible" @close="onClose">
    <a-form :form="form" :label-col="{ span:5 }" :wrapper-col="{ span: 16 }">
      <a-form-item :label="$t('region')">
        <a-select
          allowClear
          :placeholder="$t('please_select') + $t('region')"
          show-search
          :filter-option="filterOption"
          v-decorator="[
            'regionId',
            {
              initialValue: item.regionId || ''
            }
          ]"
        >
          <a-select-option :key="region.code" :value="region.code" v-for="region in regionList">
            {{ region.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :label="$t('province')">
        <a-select
          allowClear
          show-search
          :filter-option="filterOption"
          :placeholder="$t('please_select') + $t('province')"
          v-decorator="[
            'provinceId',
            {
              initialValue: item.provinceId || ''
            }
          ]"
          @change="handleProvinceChange"
        >
          <a-select-option
            :key="province.code"
            :value="province.code"
            v-for="province in provinceList"
          >
            {{ province.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :label="$t('city')">
        <a-select
          allowClear
          show-search
          :filter-option="filterOption"
          :placeholder="$t('please_select') + $t('city')"
          v-decorator="[
            'cityId',
            {
              initialValue: item.cityId || ''
            }
          ]"
          @change="handleCityChange"
        >
          <a-select-option :key="city.code" :value="city.code" v-for="city in cityList">
            {{ city.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :label="$t('time')">
        <a-range-picker v-decorator="['rangetimepicker']" show-time format="YYYY-MM-DD HH:mm:ss" style="width:100%;" />
      </a-form-item>
    </a-form>
    <div style="text-align:center;padding-bottom:10px;" slot="footer">
      <a-button  @click="save" type="primary">{{$t('common_search')}}</a-button>
      <a-button @click="onReset" style="margin-left: 10px;" type="default">{{
        $t('common_reset')
      }}</a-button>
    </div>
  </dragModal>
</template>
<script>
import {
  AuthorityDomainServiceProxy,
  RegionServiceProxy
} from '@/service-proxies/app-v2/system.service-proxies'
const adsp = new AuthorityDomainServiceProxy()
const rsp = new RegionServiceProxy()
import dayjs from 'dayjs'

import R from 'ramda'

const resetProp = (from, to) => R.pipe(R.prop(from), R.objOf(to))

const tranformTreeShape = (data) => {
  const setLabel = resetProp('title', 'label')
  const setValue = resetProp('id', 'value')
  const setChildren = R.pipe(
    R.prop('children'),
    R.ifElse(
      R.either(R.isNil, R.isEmpty),
      R.empty,
      R.pipe(R.map(tranformTreeShape), R.objOf('children'))
    )
  )

  return R.converge(R.unapply(R.mergeAll), [setLabel, setValue, setChildren])(data)
}

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      rolesList: [],
      value: undefined,
      deptIds: [],
      loading: false,
      cityValue: '',
      provinceList: [],
      cityList: [],
      treeData: [],
      regionList: []
    }
  },
  async created() {
    await this.getAuthorityDomainList()
    await this.getRegionListList()
    this.provinceList = await this.getRegionList()
  },
  computed: {
    editProvince() {
      let value = ''
      if (this.item && this.item.provinceName) {
        const province = this.provinceList.find((res) => res.name === this.item.provinceName)
        if (province) {
          value = province.code
        }
        this.getCityList(value)
      }
      return value
    },
    editCity() {
      let value = ''
      if (this.item && this.item.cityName) {
        const city = this.cityList.find((res) => res.name === this.item.cityName)
        if (city) {
          value = city.code
        }
      }
      return value
    }
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    handleProvinceChange(value) {
      this.getCityList(value)
      if (this.cityValue) {
        this.form.setFieldsValue({
          cityId: ''
        })
      }
    },
    handleCityChange(value) {
      this.cityValue = value
    },
    onClose() {
      
      this.$emit('close')
    },
    onReset(){
      this.form.resetFields()
    },
    save() {
      this.form.validateFields((err, values) => {
        if (!err) {
          const data = { ...values }
          const region = this.regionList.find((res) => res.code === values.regionId)
          if (region) {
            data.areaName = region.name
          }
          const province = this.provinceList.find((res) => res.code === values.provinceId)
          if (province) {
            data.provinceName = province.name
          }
          const city = this.cityList.find((res) => res.code === values.cityId)
          if (city) {
            data.cityName = city.name
          }
          if (values.rangetimepicker && values.rangetimepicker[0]) {
            data.beginTime = dayjs(values.rangetimepicker[0]).format('YYYY-MM-DD HH:mm:ss')
          } else {
            data.beginTime = ''
          }
          if (values.rangetimepicker && values.rangetimepicker[1]) {
            data.endTime = dayjs(values.rangetimepicker[1]).format('YYYY-MM-DD HH:mm:ss')
          } else {
            data.endTime = ''
          }
          this.$emit('advanceSearch', data)
          // this.form.resetFields()
        }
      })
    },
    async getRegionListList() {
      this.regionList = await (await rsp.select()).data
    },
    async getCityList(value) {
      this.cityList = await (await rsp.select(value)).data
    },
    async getRegionList() {
      return await (await rsp.selectByLevel()).data
    },
    async getAuthorityDomainList() {
      const { data } = await adsp.getEnableTreeList()
      const tree = tranformTreeShape(data[0])
      tree.selectable = false
      this.treeData = [tree]
    }
  }
}
</script>
